import { atom } from 'recoil';

const state = {
  practiceState: atom({
    key: 'kioskPracticeState',
    default: {
      name: '',
      logo: '',
      loaded: false
    }
  }),
  // True while a card-present sale is handed to the reader and still waiting on its outcome.
  saleArmedState: atom({
    key: 'kioskSaleArmedState',
    default: false
  })
};

export default state;
